<template>
  <div :class="classList">
    <slot name="gridItem" />
  </div>
</template>

<script>
import addSlotClasses from '@/components/deprecated/mixins/slotClassAddition';

export default {
  mixins: [addSlotClasses],
  name: 'VGrid',
  introduction: 'A layout grid based on CSS grid.',
  props: {
    gutter: {
      type: [Boolean],
      default: true,
      note: 'Adds a gap between rows and columns',
    },
  },
  data() {
    return {
      gridItemClass: 'o-grid__item',
    };
  },
  updated() {
    this.addSlotClasses();
  },
  mounted() {
    this.addSlotClasses();
  },
  computed: {
    classList() {
      const defaultClass = 'o-grid';
      const gutter = !this.gutter ? ' o-grid--no-gutter' : '';
      return defaultClass + gutter;
    },
  },
};
</script>

<style scoped>
.o-grid {
  margin: 0 -1.5%;
  padding-right: 1.5%;
  position: relative;
}

.o-grid:after {
  content: '';
  display: block;
  clear: both;
}

.o-grid__item {
  float: left;
  padding: 0 1.5%;
  padding-right: 0;
}

.o-grid__item--1 {
  width: 8.33333%;
}

.o-grid__item--1:nth-child(1n + 13) {
  margin-top: 15px;
}

.o-grid__item--1:nth-child(12n + 13) {
  clear: left;
}

@supports (display: grid) {
  .o-grid__item--1 {
    width: 100%;
    grid-column: span 1;
  }
  .o-grid__item--1:nth-child(1n + 13) {
    margin-top: initial;
  }
  .o-grid__item--1:nth-child(12n + 13) {
    clear: initial;
  }
  /* @media screen and (max-width: var(--screen-size-small)) { */
  @media screen and (max-width: 665px) {
    .o-grid__item--1 {
      grid-column: span 1;
    }
  }
  /* @media screen and (max-width: var(--screen-size-xs)) { */
  @media screen and (max-width: 450px) {
    .o-grid__item--1 {
      grid-column: span 1;
    }
  }
}

.o-grid__item--2 {
  width: 16.66667%;
}

.o-grid__item--2:nth-child(1n + 7) {
  margin-top: var(--spacing-base);
}

.o-grid__item--2:nth-child(6n + 7) {
  clear: left;
}

@supports (display: grid) {
  .o-grid__item--2 {
    width: 100%;
    grid-column: span 2;
  }
  .o-grid__item--2:nth-child(1n + 7) {
    margin-top: initial;
  }
  .o-grid__item--2:nth-child(6n + 7) {
    clear: initial;
  }
  /* @media screen and (max-width: var(--screen-size-small)) { */
  @media screen and (max-width: 665px) {
    .o-grid__item--2 {
      grid-column: span 1;
    }
  }
  /* @media screen and (max-width: var(--screen-size-xs)) { */
  @media screen and (max-width: 450px) {
    .o-grid__item--2 {
      grid-column: span 1;
    }
  }
}

.o-grid__item--3 {
  width: 25%;
}

.o-grid__item--3:nth-child(1n + 5) {
  margin-top: var(--spacing-base);
}

.o-grid__item--3:nth-child(4n + 5) {
  clear: left;
}

@supports (display: grid) {
  .o-grid__item--3 {
    width: 100%;
    grid-column: span 3;
  }
  .o-grid__item--3:nth-child(1n + 5) {
    margin-top: initial;
  }
  .o-grid__item--3:nth-child(4n + 5) {
    clear: initial;
  }
  /* @media screen and (max-width: var(--screen-size-small)) { */
  @media screen and (max-width: 665px) {
    .o-grid__item--3 {
      grid-column: span 1;
    }
  }
  /* @media screen and (max-width: var(--screen-size-xs)) { */
  @media screen and (max-width: 450px) {
    .o-grid__item--3 {
      grid-column: span 1;
    }
  }
}

.o-grid__item--4 {
  width: 33.33333%;
}

.o-grid__item--4:nth-child(1n + 4) {
  margin-top: var(--spacing-base);
}

.o-grid__item--4:nth-child(3n + 4) {
  clear: left;
}

@supports (display: grid) {
  .o-grid__item--4 {
    width: 100%;
    grid-column: span 4;
  }
  .o-grid__item--4:nth-child(1n + 4) {
    margin-top: initial;
  }
  .o-grid__item--4:nth-child(3n + 4) {
    clear: initial;
  }
  /* @media screen and (max-width: var(--screen-size-small)) { */
  @media screen and (max-width: 665px) {
    .o-grid__item--4 {
      grid-column: span 1;
    }
  }
  /* @media screen and (max-width: var(--screen-size-xs)) { */
  @media screen and (max-width: 450px) {
    .o-grid__item--4 {
      grid-column: span 1;
    }
  }
}

.o-grid__item--5 {
  width: 41.66667%;
}

.o-grid__item--5:nth-child(1n + 3.4) {
  margin-top: var(--spacing-base);
}

.o-grid__item--5:nth-child(2.4n + 3.4) {
  clear: left;
}

@supports (display: grid) {
  .o-grid__item--5 {
    width: 100%;
    grid-column: span 5;
  }
  .o-grid__item--5:nth-child(1n + 3.4) {
    margin-top: initial;
  }
  .o-grid__item--5:nth-child(2.4n + 3.4) {
    clear: initial;
  }
  /* @media screen and (max-width: var(--screen-size-small)) { */
  @media screen and (max-width: 665px) {
    .o-grid__item--5 {
      grid-column: span 1;
    }
  }
  /* @media screen and (max-width: var(--screen-size-xs)) { */
  @media screen and (max-width: 450px) {
    .o-grid__item--5 {
      grid-column: span 1;
    }
  }
}

.o-grid__item--6 {
  width: 50%;
}

.o-grid__item--6:nth-child(1n + 3) {
  margin-top: var(--spacing-base);
}

.o-grid__item--6:nth-child(2n + 3) {
  clear: left;
}

@supports (display: grid) {
  .o-grid__item--6 {
    width: 100%;
    grid-column: span 6;
  }
  .o-grid__item--6:nth-child(1n + 3) {
    margin-top: initial;
  }
  .o-grid__item--6:nth-child(2n + 3) {
    clear: initial;
  }
  /* @media screen and (max-width: var(--screen-size-small)) { */
  @media screen and (max-width: 665px) {
    .o-grid__item--6 {
      grid-column: span 1;
    }
  }
  /* @media screen and (max-width: var(--screen-size-xs)) { */
  @media screen and (max-width: 450px) {
    .o-grid__item--6 {
      grid-column: span 1;
    }
  }
}

.o-grid__item--7 {
  width: 58.33333%;
}

.o-grid__item--7:nth-child(1n + 2.71429) {
  margin-top: var(--spacing-base);
}

.o-grid__item--7:nth-child(1.71429n + 2.71429) {
  clear: left;
}

@supports (display: grid) {
  .o-grid__item--7 {
    width: 100%;
    grid-column: span 7;
  }
  .o-grid__item--7:nth-child(1n + 2.71429) {
    margin-top: initial;
  }
  .o-grid__item--7:nth-child(1.71429n + 2.71429) {
    clear: initial;
  }
  /* @media screen and (max-width: var(--screen-size-small)) { */
  @media screen and (max-width: 665px) {
    .o-grid__item--7 {
      grid-column: span 1;
    }
  }
  /* @media screen and (max-width: var(--screen-size-xs)) { */
  @media screen and (max-width: 450px) {
    .o-grid__item--7 {
      grid-column: span 1;
    }
  }
}

.o-grid__item--8 {
  width: 66.66667%;
}

.o-grid__item--8:nth-child(1n + 2.5) {
  margin-top: var(--spacing-base);
}

.o-grid__item--8:nth-child(1.5n + 2.5) {
  clear: left;
}

@supports (display: grid) {
  .o-grid__item--8 {
    width: 100%;
    grid-column: span 8;
  }
  .o-grid__item--8:nth-child(1n + 2.5) {
    margin-top: initial;
  }
  .o-grid__item--8:nth-child(1.5n + 2.5) {
    clear: initial;
  }
  /* @media screen and (max-width: var(--screen-size-small)) { */
  @media screen and (max-width: 665px) {
    .o-grid__item--8 {
      grid-column: span 1;
    }
  }
  /* @media screen and (max-width: var(--screen-size-xs)) { */
  @media screen and (max-width: 450px) {
    .o-grid__item--8 {
      grid-column: span 1;
    }
  }
}

.o-grid__item--9 {
  width: 75%;
}

.o-grid__item--9:nth-child(1n + 2.33333) {
  margin-top: var(--spacing-base);
}

.o-grid__item--9:nth-child(1.33333n + 2.33333) {
  clear: left;
}

@supports (display: grid) {
  .o-grid__item--9 {
    width: 100%;
    grid-column: span 9;
  }
  .o-grid__item--9:nth-child(1n + 2.33333) {
    margin-top: initial;
  }
  .o-grid__item--9:nth-child(1.33333n + 2.33333) {
    clear: initial;
  }
  /* @media screen and (max-width: var(--screen-size-small)) { */
  @media screen and (max-width: 665px) {
    .o-grid__item--9 {
      grid-column: span 1;
    }
  }
  /* @media screen and (max-width: var(--screen-size-xs)) { */
  @media screen and (max-width: 450px) {
    .o-grid__item--9 {
      grid-column: span 1;
    }
  }
}

.o-grid__item--10 {
  width: 83.33333%;
}

.o-grid__item--10:nth-child(1n + 2.2) {
  margin-top: var(--spacing-base);
}

.o-grid__item--10:nth-child(1.2n + 2.2) {
  clear: left;
}

@supports (display: grid) {
  .o-grid__item--10 {
    width: 100%;
    grid-column: span 10;
  }
  .o-grid__item--10:nth-child(1n + 2.2) {
    margin-top: initial;
  }
  .o-grid__item--10:nth-child(1.2n + 2.2) {
    clear: initial;
  }
  /* @media screen and (max-width: var(--screen-size-small)) { */
  @media screen and (max-width: 665px) {
    .o-grid__item--10 {
      grid-column: span 1;
    }
  }
  /* @media screen and (max-width: var(--screen-size-xs)) { */
  @media screen and (max-width: 450px) {
    .o-grid__item--10 {
      grid-column: span 1;
    }
  }
}

.o-grid__item--11 {
  width: 91.66667%;
}

.o-grid__item--11:nth-child(1n + 2.09091) {
  margin-top: var(--spacing-base);
}

.o-grid__item--11:nth-child(1.09091n + 2.09091) {
  clear: left;
}

@supports (display: grid) {
  .o-grid__item--11 {
    width: 100%;
    grid-column: span 11;
  }
  .o-grid__item--11:nth-child(1n + 2.09091) {
    margin-top: initial;
  }
  .o-grid__item--11:nth-child(1.09091n + 2.09091) {
    clear: initial;
  }
  /* @media screen and (max-width: var(--screen-size-small)) { */
  @media screen and (max-width: 665px) {
    .o-grid__item--11 {
      grid-column: span 1;
    }
  }
  /* @media screen and (max-width: var(--screen-size-xs)) { */
  @media screen and (max-width: 450px) {
    .o-grid__item--11 {
      grid-column: span 1;
    }
  }
}

.o-grid__item--12 {
  width: 100%;
}

.o-grid__item--12:nth-child(1n + 2) {
  margin-top: var(--spacing-base);
}

.o-grid__item--12:nth-child(1n + 2) {
  clear: left;
}

@supports (display: grid) {
  .o-grid__item--12 {
    width: 100%;
    grid-column: span 12;
  }
  .o-grid__item--12:nth-child(1n + 2) {
    margin-top: initial;
  }
  .o-grid__item--12:nth-child(1n + 2) {
    clear: initial;
  }
  /* @media screen and (max-width: var(--screen-size-small)) { */
  @media screen and (max-width: 665px) {
    .o-grid__item--12 {
      grid-column: span 1;
    }
  }
  /* @media screen and (max-width: var(--screen-size-xs)) { */
  @media screen and (max-width: 450px) {
    .o-grid__item--12 {
      grid-column: span 1;
    }
  }
}

.o-grid--no-gutter {
  margin: 0;
  padding-right: initial;
}

.o-grid--no-gutter > .o-grid__item {
  padding: 0;
}

  /* @media screen and (max-width: var(--screen-size-small)) { */
  @media screen and (max-width: 665px) {
  .o-grid:not(.o-grid--no-collapse-large) {
    width: 100%;
  }
}

  /* @media screen and (max-width: var(--screen-size-xs)) { */
  @media screen and (max-width: 450px) {
  .o-grid__item {
    width: 100%;
  }
}

@supports (display: grid) {
  .o-grid {
    margin: initial;
    padding-right: initial;
    position: relative;
    display: grid;
    grid-column-gap: var(--spacing-base);
    grid-row-gap: var(--spacing-base);
    grid-template-columns: repeat(12, 1fr);
    /* margin-bottom: -var(--spacing-base); */
  }
  .o-grid::after {
    display: none;
  }
  .o-grid__item {
    float: none;
    padding: 0;
    margin: 0;
  }
  .o-grid--no-gutter {
    grid-column-gap: 0;
    grid-row-gap: 0;
    margin-bottom: auto;
  }
  /* @media screen and (max-width: var(--screen-size-small)) { */
  @media screen and (max-width: 665px) {
    .o-grid:not(.o-grid--no-collapse-large) {
      grid-template-columns: 100%;
    }
  }
  /* @media screen and (max-width: var(--screen-size-xs)) { */
  @media screen and (max-width: 450px) {
    .o-grid {
      grid-template-columns: 100%;
    }
  }
}
</style>
